{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -5.671066885204624,
              35.60087853504402
            ],
            [
              -0.5477078221992713,
              35.25978785841211
            ],
            [
              3.7548188267220723,
              36.548677487960646
            ],
            [
              7.667842126196831,
              35.71908891916702
            ],
            [
              10.120392463161352,
              36.18664141701788
            ],
            [
              9.527082532000804,
              33.880533277501925
            ],
            [
              12.551747100655604,
              31.789707115955352
            ],
            [
              17.758498955941235,
              39.21484084598009
            ],
            [
              9.114709100954457,
              44.89876599955625
            ],
            [
              3.307834942093905,
              44.173035673150736
            ],
            [
              -1.8169172905893447,
              39.899281062401144
            ],
            [
              -2.0780193114940175,
              38.21061844438273
            ],
            [
              -5.526203813438201,
              37.30441292819833
            ],
            [
              -5.671066885204624,
              35.60087853504402
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}